import { getCommonFasesFiltersQS } from './getFacesQS';

export const getFacesCountQS = (obj) => getCommonFasesFiltersQS(obj);
